<template>

	<Teleport to="#popups">
		<div class="overlay-wrapper" :class="{transition: canTransition, hidden: !isActive || !stepperSteps?.length, active: isActive && stepperSteps?.length, noOverlay: currNoOverlay}" @click.self="clickOverlay" :style="zIndex ? 'z-index: '+zIndex : ''">
			<div class="bottom-sheet-container">
				<div class="bottom-sheet active-bottom-sheet" style="max-width: 100%; width: 960px;">
					<div class="bottom-sheet-measurer" :class="{activeScroll: activeScrollbar}">
						<div class="top-icon-container" @click="clickToggleIcon" :title="getString(isActive ? 'hide' : 'show')">
<!--							<div class="top-icon" v-html="getIcon('iconMinus')"></div>-->
							<div class="top-icon">
								<AppChevronIcon :size="15" direction="down" color="var(--color-bg)" />
							</div>

						</div>
						<div class="bottom-sheet-content bottom-sheet-content-active">
							<div class="funnel-back-row">
								<AppButton class="funnel-back-button" icon-left="chevron" :text="getString('back')" outline @click="$emit('back-to-funnel-choice')" />
							</div>
							<slot name="prepend-slot"></slot>
							<AppImageBanner
								v-if="activeBanner"
								:src="bannerData?.src"
								:title="bannerData?.title"
								:text="bannerData?.text || ''"
								@close="closeImageBanner"
							/>
							<FunnelStepsBottomSheetStepper ref="stepper-list" :steps="stepperSteps" :progress="stepperProgress" @go-to-menu="$emit('go-to-menu')">
								<template v-for="(step, index) in stepperSteps" :key="index" v-slot:[step.slotName]="{item}">
									<slot :name="step.slotName" :item="step" />
								</template>
							</FunnelStepsBottomSheetStepper>
							<slot name="append-slot"></slot>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Teleport>
	<div class="bottom-steps-container" @click="toggleStatus(!isActive)" :style="zIndex ? 'z-index: '+zIndex : ''">
		<div class="top-icon-container" :title="getString(isActive ? 'hide' : 'show')">
			<div class="top-icon">
				<AppChevronIcon class="chevron-icon" :size="15" :direction="isActive ? 'down' : 'up'" color="var(--color-bg)" />
			</div>
		</div>
		<div class="bottom-sheet-content bottom-sheet-content-not-active">
			<FunnelStepsBottomSheetSteps :progress="stepperProgress" :steps="stepperSteps" />
		</div>
	</div>
</template>

<script>
import FunnelStepsBottomSheetSteps from "@/console-new/components/shared/FunnelStepsBottomSheetSteps.vue";
import FunnelStepsBottomSheetStepper from "@/console-new/components/shared/FunnelStepsBottomSheetStepper.vue";
import AppImageBanner from "@/shared/components/AppImageBanner.vue";
import {useValuesStore, useLanguageStore, useSvgStore} from "@/shared/stores";
import AppChevronIcon from "@/shared/components/AppChevronIcon.vue";
import AppButton from "@/shared/components/AppButton.vue";
import {lockBodyScroll, unlockBodyScroll} from "@/shared/helpers/scrollLock";

export default {
	setup() {
		const valuesStore = useValuesStore();
		const svgStore = useSvgStore();
		const languageStore = useLanguageStore();
		return {getString: languageStore.getString, valuesStore, getIcon: svgStore.get};
	},
	name: "FunnelStepsBottomSheet",
	emits: ["toggling-popup", "click-overlay", "go-to-menu", "back-to-funnel-choice"],
	components: {AppButton, AppChevronIcon, FunnelStepsBottomSheetSteps, FunnelStepsBottomSheetStepper, AppImageBanner},
	data() {
		return {
			isActive: this.active,
			activeScrollbar: false,
			currNoOverlay: this.noOverlay,
			escListener: null,
			activeBanner: true
		}
	},
	props: {
		id: {
			type: String,
			default: null
		},
		noOverlay: {
			type: Boolean,
			default: false
		},
		active: {
			type: Boolean,
			default: false
		},
		canTransition: {
			type: Boolean,
			default: false
		},
		forceWidth: {
			type: String,
			default: null,
			validator(value) {
				return value === null || value.includes('px') || value.includes('%');
			}
		},
		zIndex: {
			type: Number,
			default: null
		},
		stepperSteps: {
			type: Array,
			default: () => []
		},
		stepperProgress: {
			type: Number,
			default: 1
		},
		bannerData: {
			type: Object,
			default: null
		}
	},
	methods: {
		closeImageBanner() {
			this.activeBanner = false;
			if(typeof sessionStorage !== 'undefined') {
				sessionStorage.setItem('hideFunnelBanner', '1');
			}
		},
		clickOverlay() {
			this.$emit('click-overlay');
			if(this.isActive) {
				this.toggleStatus(false);
			}
		},
		toggleStatus(newStatus = !this.isActive) {
			this.isActive = newStatus;
			this.updateScroll();
			this.$emit("toggling-popup", this.isActive);
		},
		clickToggleIcon() {
			this.toggleStatus();
		},
        updateScroll() {
            if(!this.currNoOverlay && this.isActive) {
                if(!this._scrollLocked) {
                    lockBodyScroll();
                    this._scrollLocked = true;
                }
            } else if(this._scrollLocked) {
                unlockBodyScroll();
                this._scrollLocked = false;
            }
        },
	},
	created() {
		if(!document.getElementById("popups")) {
			let popups = document.createElement("div");
			popups.id = "popups";
			document.body.appendChild(popups);
		}
		if(typeof sessionStorage !== 'undefined') {
			if(sessionStorage.getItem('hideFunnelBanner')) {
				this.activeBanner = false;
			}
		}
	},
	mounted() {
		setTimeout(() => {
			if(this.isActive) {
				this.activeScrollbar = true;
			}
		}, 360);

		this.escListener = (e) => {
			if (e.keyCode === 27) {
				this.clickOverlay();
			}
		}
		document.addEventListener('keyup', this.escListener);

		if(this.isActive) {
			this.updateScroll();
		}
	},
	beforeUnmount() {
		document.removeEventListener('keyup', this.escListener);
		if(this._scrollLocked) {
			unlockBodyScroll();
			this._scrollLocked = false;
		}
	},
	watch: {
		active(newStatus) {
			this.toggleStatus(newStatus);
		},
		isActive(newStatus) {
			if(document.activeElement) {
				document.activeElement.blur();
			}
			let stepsElement = this.$refs['stepper-list'];
			if(newStatus) {
				if(stepsElement && stepsElement.resetDropdown) {
					stepsElement.resetDropdown();
				}
				setTimeout(() => {
					if(this.isActive) {
						this.activeScrollbar = true;
					}
				}, 360);
			} else {
				this.activeScrollbar = false;
				setTimeout(() => {
					if(stepsElement && stepsElement.resetDropdown) {
						stepsElement.resetDropdown();
					}
				}, 360);
			}
		},
		noOverlay() {
			this.currNoOverlay = this.noOverlay;
            this.updateScroll();
		},
		"valuesStore.forceCloseAllBottomSheets"(newStatus) {
			if(newStatus) {
				this.toggleStatus(false);
			}
		}
	},
}
</script>

<style lang="scss" scoped>

.overlay-wrapper {
	z-index: 1000;
	@include centered;
	position: fixed;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: var(--color-bg-overlay);
	visibility: visible;

	&.transition {
		transition: visibility 0.3s $transition, background-color .3s $transition, opacity .3s $transition;
		&.active .bottom-sheet-container .bottom-sheet.active-bottom-sheet {
			transition: padding-top 0s .3s;
		}
		.bottom-sheet-container {
			transition: opacity .2s $transition .1s, transform .2s $transition .1s;
			.bottom-sheet {
				transition: height 0.3s ease;
			}
		}
		&.hidden .bottom-sheet-container {
			transition: opacity .2s $transition, transform .2s $transition;
		}
	}

	&.noOverlay {
		background-color: transparent;
		pointer-events: none;

		.bottom-sheet-container .bottom-sheet {
			box-shadow: 0 -5px 80px var(--color-box-shadow-2);
		}
	}

	&:not(.active) {
		.bottom-sheet-container .bottom-sheet {
			background-color: var(--color-bg);
			.bottom-sheet-measurer .top-icon-container {
				background-color: var(--color-bg);
				box-shadow: 0px 2px 5px 0px var(--color-box-shadow-2) inset;
			}

		}
	}

	&.active {
		backdrop-filter: blur(5px);
		-webkit-backdrop-filter: blur(5px);
		.bottom-sheet-container .bottom-sheet.active-bottom-sheet {
			//transition: padding-top 0s .3s;
			padding-top: 30px;
		}

	}
	.bottom-sheet-container.bottom-sheet-container-not-active .bottom-sheet {
		border-radius: 0 0 0 0;
	}

	.bottom-sheet-container {
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		align-items: center;
		width: 100%;
		height: 100%;
		//transition: opacity .2s $transition .1s, transform .2s $transition .1s;
		opacity: 1;
		transform: translateY(0);
		pointer-events: none;

		.bottom-sheet {
			width: 100%;
			max-height: calc(95% - 30px);
			padding: 0;
			border-radius: 20px 20px 0 0;
			pointer-events: all;
			//transition: height 0.3s ease;
			position: relative;
			background-color: var(--color-bg);
			box-shadow: inset 0 1px 2px var(--color-box-shadow-3);

			.bottom-sheet-measurer {
				overflow-y: hidden;
				overflow-x: hidden;
				@include hideScrollbar();
				height: 100%;

				.top-icon-container {
					position: absolute;
					top: 0;
					left: 50%;
					transform: translate(-50%, -25px);
					width: 50px;
					height: 50px;
					background-color: var(--color-bg);
					border-radius: 18px;
					z-index: 1;
					cursor: pointer;
					box-shadow: inset 0 1px 2px var(--color-box-shadow-3);
				}

				.top-icon {
					@include centered;
					margin: 5px auto;
					width: 40px;
					height: 40px;
					padding: 5px;
					background: linear-gradient(225deg, #28EDBF 7.5%, #0752A3 92.5%);
					box-shadow: inset 0px 4px 4px 0px var(--color-box-shadow-3);
					border-radius: 13px;
					/*:deep(svg) {
						width: 16px;
						height: 20px;
						.fill { fill: var(--color-bg); }
						.stroke { stroke: var(--color-bg); }
					}*/
				}

				.bottom-sheet-content {
					overflow-y: auto;
					height: auto;

					&-active {
						padding: 0 30px 30px 30px;
					}
					&-not-active {
						box-shadow: 0px 2px 5px 0px var(--color-box-shadow-2) inset;
					}
					.funnel-back-row {
						display: flex;
						justify-content: flex-start;
						margin-bottom: 16px;
					}
					.image-banner {
						background-color: var(--color-alpha-1);
					}
				}
				&.activeScroll {
					overflow-y: auto;
				}

				@media (max-width: 600px) {

					.top-icon-container {
						transform: translate(-50%, -20px);
						width: 40px;
						height: 20px;
						background-color: var(--color-bg);
						border-radius: 12px 12px 0 0;
					}

					.top-icon {
						margin: 4px auto;
						width: 32px;
						height: 32px;
						padding: 3px;
						border-radius: 9px;
						/*:deep(svg) {
							width: 16px;
							height: 22px;
						}*/
					}
				}

				@media (max-width: 480px) {

					.top-icon-container {
						transform: translate(-50%, -16px);
						width: 32px;
						height: 16px;
						background-color: var(--color-bg);
						border-radius: 12px 12px 0 0;
					}

					.top-icon {
						margin: 2px auto;
						width: 26px;
						height: 26px;
						padding: 3px;
						border-radius: 9px;
						/*:deep(svg) {
							width: 14px;
							height: 20px;
						}*/
					}

					.bottom-sheet-content-active { padding: 0 10px 10px 10px; }
				}

			}

		}

	}

	@media (max-width: 480px) {
		&.active .bottom-sheet-container .bottom-sheet { padding-top: 10px; }
	}

	&.hidden {
		visibility: hidden;
		background-color: transparent;
		opacity: 0;
		pointer-events: none;

		.bottom-sheet-container {
			opacity: 0;
			transform: translateY(calc(100vh + 200px));
			//transition: opacity .2s $transition, transform .2s $transition;
		}
	}
}
@keyframes bounceIn {
  0%   { transform: scale(1,1)      translateY(0); }
  9%   { transform: scale(1,1)      translateY(0); }
  12%  { transform: scale(1.1,.9)   translateY(4px); }
  15%  { transform: scale(.95,1.05) translateY(-4px); }
  15.9% { transform: scale(1,1)      translateY(0); }
  17.1% { transform: scale(1,1)      translateY(-2px); }
  30%  { transform: scale(1,1)      translateY(0); }
  100% { transform: scale(1,1)      translateY(0); }
}

.bottom-steps-container {
	cursor: pointer;
	position: fixed;
	bottom: 0;
	width: 100%;
	background-color: var(--bg-0);

	.top-icon-container {
		position: absolute;
		top: -25px;
		left: calc(50% - 25px);
		width: 50px;
		height: 50px;
		background-color: var(--color-bg);
		border-radius: 18px;
		z-index: 1;
		cursor: pointer;
		box-shadow: inset 0 1px 2px var(--color-box-shadow-3);
		animation: bounceIn 10s infinite;
		transform-origin: center;

		.top-icon {
			@include centered;
			margin: 5px auto;
			width: 40px;
			height: 40px;
			padding: 5px;
			box-shadow: inset 0px 4px 4px 0px var(--color-box-shadow-3);
			border-radius: 13px;
			background: linear-gradient(225deg, #28EDBF 7.5%, #0752A3 92.5%);
		}
	}

	@media (max-width: 600px) {
		.top-icon-container {
			top: -20px;
			left: calc(50% - 20px);
			width: 40px;
			height: 20px;
			background-color: var(--color-bg);
			border-radius: 12px 12px 0 0;

			.top-icon {
				margin: 4px auto;
				width: 32px;
				height: 32px;
				padding: 3px;
				border-radius: 9px;
			}
		}
	}

	@media (max-width: 480px) {
		.top-icon-container {
			top: -16px;
			left: calc(50% - 16px);
			width: 32px;
			height: 16px;
			background-color: var(--color-bg);
			border-radius: 12px 12px 0 0;

			.top-icon {
				margin: 2px auto;
				width: 26px;
				height: 26px;
				padding: 3px;
				border-radius: 9px;
			}
		}
	}

}
</style>